module.exports = __webpack_public_path__ + "img/nuxt.25803e9b.svg";